import { render } from "./LocationDescription.vue?vue&type=template&id=a24eeba2&scoped=true"
import script from "./LocationDescription.vue?vue&type=script&lang=js"
export * from "./LocationDescription.vue?vue&type=script&lang=js"

import "./LocationDescription.vue?vue&type=style&index=0&id=a24eeba2&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24eeba2"]])

export default __exports__